<template>
  <section class="page-videos">
    <div class="page-videos__filter">
      <TheFilterArticles @tabClicked="tabValue"/>
    </div>
    <div class="page-videos__wrapper">
      <div class="page-videos__video">
        <div class="page-videos__fig">
          <figure class="page-videos__image-ratio">
            <iframe
              v-if="selectedTab === 2"
              width="100%"
              :src="video2"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <iframe
              v-else-if="selectedTab === 3"
              width="100%"
              :src="video3"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <iframe
              v-else-if="selectedTab === 4"
              width="100%"
              :src="video4"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <iframe
              v-else
              width="100%"
              :src="video1"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import TheFilterArticles from '../components/TheFilterArticles.vue'

export default {
  name: 'PageVideos',
  components: { TheFilterArticles },
  data() {
    return {
      selectedTab: '1',
      video1: 'https://www.youtube.com/embed/xruwuZ91i4Q',
      video2: 'https://www.youtube.com/embed/Zu3U4j8Ndzc',
      video3: 'https://www.youtube.com/embed/KkhooZ-KdOs',
      video4: 'https://www.youtube.com/embed/Qwocy6tAAJs'
    }
  },
  methods: {
    tabValue(tab) {
      this.selectedTab = tab
    }
  }
}
</script>

<style lang="postcss">
.page-videos {
  @apply w-full mx-auto;
}
.page-videos__filter {
  @apply max-w-screen-xl mx-auto px-0;
}
.page-videos__wrapper {
  @apply w-full text-body bg-primary-lighter overflow-hidden mb-12;
}
.page-videos__video {
  @apply w-full max-w-screen-xl mx-auto;
}
.page-videos__fig {
  @apply w-full  mx-auto;
}
.page-videos__image-ratio {
  @apply mx-auto aspect-ratio-16/9 w-full bg-body-dark relative overflow-hidden;
}
.page-videos__image-ratio > iframe {
  @apply block absolute inset-y-0 inset-x-0 min-h-full min-w-full;
}
@screen md {
  .page-videos {
    @apply pt-0 mb-24;
  }
  .page-videos__video {
    @apply w-8/12;
  }
  .page-videos__filter {
    @apply pl-6;
  }
}
@screen xl {
  .page-videos__filter {
    @apply px-6;
  }
  .page-videos__fig {
    @apply w-8/12;
  }
}
</style>